<article class="panel panel-default" *ngIf="CbcExchangeData && CbcExchangeData.length">

    <div class="panel-body" style="padding-bottom: 0px;">
        <div class="table-header">

            <div class="tiaHeader" bento-test="applicable_instruments_for_exchange">APPLICABLE INSTRUMENTS FOR
                EXCHANGE OF CbC REPORTS</div>
            <!-- Header Html -->
            <div class="tiea-table-section clearfix">

                <!-- ... replicate markup, replace bindings -->
                <div class="clearfix">
                    <div class="tiea-table">
                        <div class="tiea-table-row">
                            <div class="tiea-table-cell" bento-test="jurisdiction_reporting_entity">Fiscal Year
                                Start Date</div>
                            <div class="tiea-table-cell" bento-test="jurisdiction_reporting_entity">Jurisdiction of
                                Reporting Entity</div>
                            <div class="tiea-table-cell" bento-test="jurisdiction_constituent_entity">Jurisdiction
                                of Constituent Entity</div>
                        </div>
                    </div>

                    <div
                            [ngClass]="(CbcExchangeData[0]?.hasTreaty==='Yes' || CbcExchangeData[0]?.hasTiea==='Yes') && CbcExchangeData[0].bilateralCbCCompetentAgreement==='Yes'?'greenBorderTopPack tiea-table':'tiea-table transparentBorderTopPack'">
                        <div class="tiea-table-row">
                            <div class="tiea-table-cell" style="width: 74px" bento-test="tax_treaty">Tax Treaty
                            </div>
                            <div class="tiea-table-cell" bento-test="tifa">TIEA</div>
                            <div class="tiea-table-cell" style="border-right: 1px solid #dddddd"
                                 bento-test="bilateral_CbC_competent_authority_agreement">
                                Bilateral CbC Competent Authority Agreement
                            </div>
                        </div>
                    </div>

                    <div class="cell-seprator-text" style="left: -211px;">
                        OR
                    </div>
                    <div class="cell-seprator-text" style="left: -164px;">
                        +
                    </div>

                    <div class="seprator-text">
                        OR
                    </div>


                    <div
                            [ngClass]="CbcExchangeData[0]?.hasOECD=='Yes' && CbcExchangeData[0].multilateralCbCCompetentAuthorityAgreement=='Yes'?'greenBorderTopPack tiea-table':'tiea-table transparentBorderTopPack'">
                        <div class="tiea-table-row">
                            <div class="tiea-table-cell" bento-test="mutual_assistance_convention">Mutual Assistance
                                Convention</div>
                            <div class="tiea-table-cell" style="border-right: 1px solid #dddddd"
                                 bento-test="multilateral_competent_authority_agreement">
                                Multilateral Competent Authority agreement
                            </div>
                        </div>
                    </div>

                    <div class="cell-seprator-text addSign" style="left: -204px;">+</div>
                    <div class="seprator-text">
                        OR
                    </div>

                    <div
                            [ngClass]="CbcExchangeData[0]?.hasEU==='Yes'?'greenBorderTopPack tiea-table':'tiea-table transparentBorderTopPack'">
                        <div class="tiea-table-row">
                            <div [ngClass]="CbcExchangeData[0]?.hasEU==='Yes'?'greenBackground greenBorderTopPack tiea-table-cell':'tiea-table-cell transparentBorderTopPack'"
                                 bento-test="eu_directive_administrative_co-operation">Eu Directive on Administrative
                                Co-operation</div>
                        </div>
                    </div>

                    <div class="seprator-text">
                        =
                    </div>

                    <div
                            [ngClass]="CbcExchangeData[0].exchangeOfCbCReports==='Yes'?'greenBorderTopPack tiea-table':'tiea-table transparentBorderTopPack'">
                        <div class="tiea-table-row">

                            <div style="height: 68px;"
                                 [ngClass]="CbcExchangeData[0].exchangeOfCbCReports==='Yes'?'greenBackground greenBorderTopPack tiea-table-cell':'tiea-table-cell transparentBorderTopPack'">
                                Exchange of CbC Reports
                                <i class="fa-regular fa-circle-info  m-l-4" (click)="popOverShow()"></i>
                                <!-- <img class="pointer"
                                    src="http://caterpillarcheese.orbitaxbd.com/Content/Branding/Images/web-informationIcon.png"
                                    style="margin-left: 2px;cursor:pointer;" alt="information icon"
                                    (click)="popOverShow()"> -->

                            </div>
                        </div>

                    </div>
                    <div class="cbc-exachage-pop-over" *ngIf="ReportPopOverToggle">

                        <div (click)="popOverHide()" style="display:flex; align-items:center; justify-content: flex-end;"> <i class="fa-duotone fa-regular fa-xmark"></i></div>
                        <br>
                        <div class="pop-header">Exchange of CbC Reports</div>
                        <br>
                        <div>In general, for two jurisdictions to automatically exchange CbC reports, they must have
                            CbC reporting requirements in place for the fiscal year concerned, and have either:


                            <ul>
                                <li> Signed a bilateral competent authority agreement on the exchange of CbC reports
                                    (CbC BCAA) and have a tax treaty or tax information exchange agreement in force
                                    that meets certain exchange of information requirements; or</li>
                                <li> Signed the Multilateral Competent Authority Agreement on the exchange of CbC
                                    reports (CbC MCAA) and both be signatories to and have ratified the OECD-Council
                                    of Europe Mutual Assistance Convention.</li>
                            </ul>

                            In addition to the two primary means of exchange above, EU Member States are required to
                            exchange CbC reports under the EU Directive on Administrative Cooperation in the Field
                            of Taxation (Directive 2011/16/EU) as amended by Council Directive (EU) 2016/881.
                            No other agreements between two Member States are required for the exchange.
                            <br>
                            <br>
                            <div>Note - Signatories to the CbC MCAA must indicate whether they are willing to
                                exchange with all signatories, exchange with specified signatories, or elect to be
                                classified as a "non-reciprocal jurisdiction". The OECD has not
                                yet published this information for all signatories to the CbC MCAA; therefore
                                exchange between certain signatories to the CbC MCAA is possible, but not yet
                                certain.</div>

                        </div>

                    </div>
                </div>


                <div class="clearfix tiaDataRow">

                    <div class="tiea-table">
                        <div class="tiea-table-row">
                            <div class="tiea-table-cell">{{ cbcExchangeFiscalYearStartDate | date:'MM/dd/yyyy' }}
                            </div>
                            <div class="tiea-table-cell">{{ CbcExchangeData[0].countryName1 }}</div>
                            <div class="tiea-table-cell">{{ CbcExchangeData[0].countryName2 }}</div>
                        </div>
                    </div>



                    <div
                            [ngClass]="(CbcExchangeData[0]?.hasTreaty==='Yes' || CbcExchangeData[0]?.hasTiea==='Yes') && CbcExchangeData[0]?.bilateralCbCCompetentAgreement==='Yes'?'greenBorderBottomPack tiea-table':'tiea-table transparentBorderBottomPack'">
                        <div class="tiea-table-row">
                            <div class="tiea-table-cell">
                                <span class="pull-left">{{CbcExchangeData[0]?.hasTreaty}}</span>
                                <i *ngIf="CbcExchangeData[0].hasTreatyFootnote=='Yes' && CbcExchangeData[0].cbcExchangeFootnote"
                                   style="position: relative; top:2px"
                                   [matTooltip]="CbcExchangeData[0].cbcExchangeFootnote" matTooltipPosition="below"
                                   tabindex="-1" class="fa-regular fa-circle-info  m-l-4 pull-right"></i>
                            </div>
                            <div class="tiea-table-cell">
                                <span class="pull-left">{{CbcExchangeData[0].hasTiea}}</span>
                                <i *ngIf="CbcExchangeData[0].hasTieaFootnote=='Yes' && CbcExchangeData[0].cbcExchangeFootnote"
                                   style="position: relative; top:2px"
                                   [matTooltip]="CbcExchangeData[0].cbcExchangeFootnote" matTooltipPosition="below"
                                   tabindex="-1" class="fa-regular fa-circle-info  m-l-4 pull-right"></i>
                            </div>
                            <div class="tiea-table-cell" style="border-right: 1px solid #dddddd">
                                    <span class="pull-left ng-binding">{{CbcExchangeData[0]?.bilateralCbCCompetentAgreement}}</span>
                                    <i *ngIf="CbcExchangeData[0]?.cbcBilateralEffectiveFromMessage"
                                        style="position: relative; top:2px"
                                        [matTooltip]="CbcExchangeData[0].cbcBilateralEffectiveFromMessage"
                                        matTooltipPosition="below"
                                        tabindex="-1"
                                        class="fa-regular fa-circle-info  m-l-4 pull-right">
                                    </i>

                            </div>
                        </div>
                    </div>

                    <div
                            [ngClass]="CbcExchangeData[0]?.hasOECD==='Yes' && CbcExchangeData[0]?.multilateralCbCCompetentAuthorityAgreement==='Yes'?'greenBorderBottomPack tiea-table':'tiea-table transparentBorderBottomPack'">
                        <div class="tiea-table-row">
                            <div class="tiea-table-cell">
                                <span class="pull-right">{{CbcExchangeData[0]?.hasOECD}}</span>
                            </div>
                            <div class="tiea-table-cell" style="border-right: 1px solid #dddddd">
                                    <span
                                            class="pull-left">{{CbcExchangeData[0]?.multilateralCbCCompetentAuthorityAgreement}}</span>
                                <i *ngIf="CbcExchangeData[0]?.cbCMultilateralFootnote"
                                   style="position: relative; top:2px"
                                   [matTooltip]="CbcExchangeData[0].cbCMultilateralFootnote"
                                   matTooltipPosition="below" tabindex="-1" class="fa-regular fa-circle-info  m-l-4 pull-right"></i>
                            </div>
                        </div>
                    </div>

                    <div
                            [ngClass]="CbcExchangeData[0]?.hasEU==='Yes'?'greenBorderBottomPack tiea-table':'tiea-table transparentBorderBottomPack'">
                        <div class="tiea-table-row">

                            <div class="tiea-table-cell">
                                <button *ngIf="false" class="miniBtn miniBtnFix pull-right">
                                    Yes
                                </button>
                                <span class="pull-right">{{CbcExchangeData[0]?.hasEU}}</span>
                            </div>
                        </div>
                    </div>

                    <div
                            [ngClass]="CbcExchangeData[0]?.exchangeOfCbCReports==='Yes'?'greenBorderBottomPack tiea-table':'tiea-table transparentBorderBottomPack'">
                        <div class="tiea-table-row">
                            <div class="tiea-table-cell">
                                <span class="pull-right">{{CbcExchangeData[0]?.exchangeOfCbCReports}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Start ACCORDION -->
        <!-- ================= ACCORDION ================= -->
        <mat-accordion class="custom-accordion">

            <!-- ===== COUNTRY 1 ===== -->
            <mat-expansion-panel [(expanded)]="country1AccordionOpen" class="mat-expansion-panel-custom">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{SelectedCountryName1}} CbC automatic exchange status with BEPS Inclusive Framework
                        Countries
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="scrollable-data-container">

                    <div class="tiaHeader">APPLICABLE INSTRUMENTS FOR EXCHANGE OF CbC REPORTS</div>
                    <div class="tiea-table-section clearfix">
                        <div class="clearfix">
                            <div class="tiea-table">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">Fiscal Year Start Date</div>
                                    <div class="tiea-table-cell">Jurisdiction of Reporting Entity</div>
                                    <div class="tiea-table-cell">Jurisdiction of Constituent Entity</div>
                                </div>
                            </div>


                            <div class="tiea-table transparentBorderTopPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell" style="width: 74px">Tax Treaty</div>
                                    <div class="tiea-table-cell">TIEA</div>
                                    <div class="tiea-table-cell" style="border-right: 1px solid #dddddd">
                                        Bilateral CbC Competent Authority Agreement
                                    </div>
                                </div>
                            </div>

                            <div class="cell-seprator-text" style="left: -211px;">
                                OR
                            </div>
                            <div class="cell-seprator-text" style="left: -164px;">
                                +
                            </div>

                            <div class="seprator-text">
                                OR
                            </div>


                            <div class="tiea-table transparentBorderTopPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">Mutual Assistance Convention</div>
                                    <div class="tiea-table-cell" style="border-right: 1px solid #dddddd">
                                        Multilateral Competent Authority agreement
                                    </div>
                                </div>
                            </div>

                            <div class="cell-seprator-text addSign" style="left: -204px;">+</div>
                            <div class="seprator-text">
                                OR
                            </div>


                            <div class="tiea-table transparentBorderTopPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">Eu Directive on Administrative Co-operation</div>
                                </div>
                            </div>
                            <div class="seprator-text">
                                =
                            </div>
                            <div class="tiea-table transparentBorderTopPack">
                                <div class="tiea-table-row">

                                    <div style="height: 68px;" class="tiea-table-cell transparentBorderTopPack">
                                        Exchange of CbC Reports

                                        <!-- <img class="pointer"
                                            src="http://caterpillarcheese.orbitaxbd.com/Content/Branding/Images/web-informationIcon.png"
                                            style="margin-left: 2px;" alt="information icon"> -->
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="clearfix tiaDataRow"
                             *ngFor="let tiea of CbcExchangeDataCountry1; let topIndex = index; trackBy: trackByIndex">
                            <div class="tiea-table">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">{{cbcExchangeFiscalYearStartDate |
                                        date:"MM/dd/yyyy"}}</div>
                                    <div class="tiea-table-cell">{{tiea.countryName1}}</div>
                                    <div class="tiea-table-cell">{{tiea.countryName2}}</div>
                                </div>
                            </div>

                            <div class="tiea-table transparentBorderBottomPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">
                                        <span class="pull-left">{{tiea.hasTreaty}}</span>
                                        <i *ngIf="tiea.hasTreatyFootnote=='Yes' && tiea.cbcExchangeFootnote"
                                           style="position: relative; top:2px"
                                           [matTooltip]="tiea.cbcExchangeFootnote" matTooltipPosition="below"
                                           tabindex="-1" class="fa-regular fa-circle-info  m-l-4 pull-right"></i>
                                    </div>

                                    <div class="tiea-table-cell">
                                        <span class="pull-left">{{tiea.hasTiea}}</span>
                                        <i *ngIf="tiea.hasTieaFootnote=='Yes' && tiea.cbcExchangeFootnote"
                                           style="position: relative; top:2px"
                                           [matTooltip]="tiea.cbcExchangeFootnote" matTooltipPosition="below"
                                           tabindex="-1" class="fa-regular fa-circle-info  m-l-4 pull-right"></i>

                                    </div>

                                    <div class="tiea-table-cell" style="border-right: 1px solid #dddddd">
                                            <span
                                                    class="pull-left ng-binding">{{tiea.bilateralCbCCompetentAgreement}}</span>
                                        <i *ngIf="tiea.cbcBilateralEffectiveFromMessage"
                                           style="position: relative; top:2px"
                                           [matTooltip]="tiea.cbcBilateralEffectiveFromMessage"
                                           matTooltipPosition="below" tabindex="-1"
                                           class="fa-regular fa-circle-info  m-l-4 pull-right"></i>
                                    </div>
                                </div>
                            </div>


                            <div class="tiea-table transparentBorderBottomPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">
                                        <span class="pull-right">{{tiea.hasOECD}}</span>
                                    </div>
                                    <div class="tiea-table-cell" style="border-right: 1px solid #dddddd">
                                            <span
                                                    class="pull-left">{{tiea.multilateralCbCCompetentAuthorityAgreement}}</span>
                                        <i *ngIf="tiea?.cbCMultilateralFootnote"
                                           style="position: relative; top:2px"
                                           [matTooltip]="tiea.cbCMultilateralFootnote" matTooltipPosition="below"
                                           tabindex="-1" class="fa-regular fa-circle-info  m-l-4 pull-right"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="tiea-table transparentBorderBottomPack">
                                <div class="tiea-table-row">

                                    <div class="tiea-table-cell">
                                        <button *ngIf="false" class="miniBtn miniBtnFix pull-right">
                                            Yes
                                        </button>
                                        <span class="pull-right">{{tiea.hasEU}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="tiea-table transparentBorderBottomPack">
                                <div class="tiea-table-row">

                                    <div class="tiea-table-cell">
                                        <span class="pull-right">{{tiea.exchangeOfCbCReports}}</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>

            <!-- ===== COUNTRY 2 ===== -->
            <mat-expansion-panel [(expanded)]="country2AccordionOpen" class="mat-expansion-panel-custom">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{SelectedCountryName2}} CbC automatic exchange status with BEPS Inclusive Framework
                        Countries
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="scrollable-data-container">
                    <div class="tiaHeader">APPLICABLE INSTRUMENTS FOR EXCHANGE OF CbC REPORTS</div>
                    <div class="tiea-table-section clearfix">
                        <div class="clearfix">
                            <div class="tiea-table">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">Fiscal Year Start Date</div>
                                    <div class="tiea-table-cell">Jurisdiction of Reporting Entity</div>
                                    <div class="tiea-table-cell">Jurisdiction of Constituent Entity</div>
                                </div>
                            </div>

                            <div class="tiea-table transparentBorderTopPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell" style="width: 74px">Tax Treaty</div>
                                    <div class="tiea-table-cell">TIEA</div>
                                    <div class="tiea-table-cell" style="border-right: 1px solid #dddddd">
                                        Bilateral CbC Competent Authority Agreement
                                    </div>
                                </div>
                            </div>

                            <div class="cell-seprator-text" style="left: -211px;">
                                OR
                            </div>
                            <div class="cell-seprator-text" style="left: -164px;">
                                +
                            </div>

                            <div class="seprator-text">
                                OR
                            </div>


                            <div class="tiea-table transparentBorderTopPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">Mutual Assistance Convention</div>
                                    <div class="tiea-table-cell" style="border-right: 1px solid #dddddd">
                                        Multilateral Competent Authority agreement
                                    </div>
                                </div>
                            </div>

                            <div class="cell-seprator-text addSign" style="left: -204px;">+</div>
                            <div class="seprator-text">
                                OR
                            </div>


                            <div class="tiea-table transparentBorderTopPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">Eu Directive on Administrative Co-operation</div>
                                </div>
                            </div>
                            <div class="seprator-text">
                                =
                            </div>

                            <div class="tiea-table transparentBorderTopPack">
                                <div class="tiea-table-row">
                                    <div style="height: 68px;" class="tiea-table-cell transparentBorderTopPack">
                                        Exchange of CbC Reports
                                        <!-- <img class="pointer"
                                            src="http://caterpillarcheese.orbitaxbd.com/Content/Branding/Images/web-informationIcon.png"
                                            style="margin-left: 2px;" alt="information icon"> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="clearfix tiaDataRow"
                             *ngFor="let tiea of CbcExchangeDataCountry2; let topIndex = index; trackBy: trackByIndex">
                            <div class="tiea-table">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">{{cbcExchangeFiscalYearStartDate |
                                        date:"MM/dd/yyyy"}}</div>
                                    <div class="tiea-table-cell">{{tiea.countryName1}}</div>
                                    <div class="tiea-table-cell">{{tiea.countryName2}}</div>
                                </div>
                            </div>

                            <div class="tiea-table transparentBorderBottomPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">
                                        <span class="pull-left">{{tiea.hasTreaty}}</span>
                                        <i *ngIf="tiea.hasTreatyFootnote=='Yes' && tiea.cbcExchangeFootnote"
                                           style="position: relative; top:2px"
                                           [matTooltip]="tiea.cbcExchangeFootnote" matTooltipPosition="below"
                                           tabindex="-1" class="fa-regular fa-circle-info  m-l-4 pull-right"></i>
                                    </div>
                                    <div class="tiea-table-cell">
                                        <span class="pull-left">{{tiea.hasTiea}}</span>
                                        <i *ngIf="tiea.hasTieaFootnote=='Yes' && tiea.cbcExchangeFootnote"
                                           style="position: relative; top:2px"
                                           [matTooltip]="tiea.cbcExchangeFootnote" matTooltipPosition="below"
                                           tabindex="-1" class="fa-regular fa-circle-info  m-l-4 pull-right"></i>
                                    </div>
                                    <div class="tiea-table-cell" style="border-right: 1px solid #dddddd">
                                            <span
                                                    class="pull-left ng-binding">{{tiea.bilateralCbCCompetentAgreement}}</span>
                                        <i *ngIf="tiea.cbcBilateralEffectiveFromMessage"
                                           style="position: relative; top:2px"
                                           [matTooltip]="tiea.cbcBilateralEffectiveFromMessage"
                                           matTooltipPosition="below" tabindex="-1"
                                           class="fa-regular fa-circle-info  m-l-4 pull-right"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="tiea-table transparentBorderBottomPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">
                                        <span class="pull-right">{{tiea.hasOECD}}</span>
                                    </div>
                                    <div class="tiea-table-cell" style="border-right: 1px solid #dddddd">
                                            <span
                                                    class="pull-left">{{tiea.multilateralCbCCompetentAuthorityAgreement}}</span>
                                        <i *ngIf="tiea.cbCMultilateralFootnote"
                                           style="position: relative; top:2px"
                                           [matTooltip]="tiea.cbCMultilateralFootnote" matTooltipPosition="below"
                                           tabindex="-1" class="fa-regular fa-circle-info  m-l-4 pull-right"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="tiea-table transparentBorderBottomPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">
                                        <button *ngIf="false" class="miniBtn miniBtnFix pull-right">
                                            Yes
                                        </button>
                                        <span class="pull-right">{{tiea.hasEU}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="tiea-table transparentBorderBottomPack">
                                <div class="tiea-table-row">
                                    <div class="tiea-table-cell">
                                        <span class="pull-right">{{tiea.exchangeOfCbCReports}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>

        </mat-accordion>

        <!-- End ACCORDION  -->

    </div>
</article>
